var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class DataReconciliationApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'data-reconciliation';
    }
    initiateReconciliationProcess(queueParams_1) {
        return __awaiter(this, arguments, void 0, function* (queueParams, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}`, data: queueParams }, apiParams));
        });
    }
    listReconciliations(filterOptions_1) {
        return __awaiter(this, arguments, void 0, function* (filterOptions, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}`, params: filterOptions }, apiParams));
        });
    }
    getReconciliationById(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/${id}` }, apiParams));
        });
    }
    removeReconciliation(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'DELETE', route: `${this.apiBasePath}`, params: { id } }, apiParams));
        });
    }
}
//# sourceMappingURL=index.js.map